import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination is-centered"
}
const _hoisted_2 = { class: "pagination-list" }
const _hoisted_3 = ["onClick", "disabled"]
const _hoisted_4 = {
  key: 1,
  class: "pagination is-centered",
  role: "navigation",
  "aria-label": "pagination"
}
const _hoisted_5 = { class: "pagination-list" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "pagination-ellipsis" }, "…", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "pagination-ellipsis" }, "…", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_table = _resolveComponent("custom-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_custom_table, {
      elements: _ctx.elements,
      "columns-config": _ctx.columnsConfig,
      "elements-key": _ctx.elementsKey,
      "table-classes": _ctx.tableClasses,
      "is-loading": _ctx.isLoading,
      "row-classes-fn": _ctx.rowClassesFn
    }, _createSlots({ _: 2 }, [
      _renderList(_ctx.slotNames, (slotName) => {
        return {
          name: slotName,
          fn: _withCtx(({ row: row, columnConfig: columnConfig }) => [
            _renderSlot(_ctx.$slots, slotName, {
              row: row,
              columnConfig: columnConfig
            })
          ])
        }
      })
    ]), 1032, ["elements", "columns-config", "elements-key", "table-classes", "is-loading", "row-classes-fn"]),
    (_ctx.pages.length < _ctx.longPaginatorThreshold && _ctx.pages.length != 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (a) => {
              return (_openBlock(), _createElementBlock("li", { key: a }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.onPaginationClick(a)),
                  class: _normalizeClass(["button pagination-link", { 'is-current': a === _ctx.currentPage }]),
                  disabled: a === _ctx.currentPage
                }, _toDisplayString(a), 11, _hoisted_3)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pages.length >= _ctx.longPaginatorThreshold && _ctx.pages.length != 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
          _withDirectives(_createElementVNode("button", {
            class: "button pagination-previous",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPaginationClick(_ctx.currentPage - 1)))
          }, " Anterior ", 512), [
            [_vShow, _ctx.currentPage - 1 > 0]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "button pagination-next",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPaginationClick(_ctx.currentPage + 1)))
          }, " Siguiente ", 512), [
            [_vShow, _ctx.currentPage < _ctx.pages.length]
          ]),
          _createElementVNode("ul", _hoisted_5, [
            _withDirectives(_createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "button pagination-link",
                "aria-label": "Goto first page",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPaginationClick(1)))
              }, " 1 ")
            ], 512), [
              [_vShow, _ctx.currentPage - 2 > 0]
            ]),
            _withDirectives(_createElementVNode("li", null, _hoisted_7, 512), [
              [_vShow, _ctx.currentPage - 3 > 0]
            ]),
            _withDirectives(_createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "button pagination-link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPaginationClick(_ctx.currentPage - 1))),
                "aria-label": `Ir a pagina ${_ctx.currentPage - 1}`
              }, _toDisplayString(_ctx.currentPage - 1), 9, _hoisted_8)
            ], 512), [
              [_vShow, _ctx.currentPage - 1 > 0]
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "pagination-link is-current",
                disabled: "",
                "aria-label": `Pagina ${_ctx.currentPage}`,
                "aria-current": "page"
              }, _toDisplayString(_ctx.currentPage), 9, _hoisted_9)
            ]),
            _withDirectives(_createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "pagination-link button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPaginationClick(_ctx.currentPage + 1))),
                "aria-label": "Goto page"
              }, _toDisplayString(_ctx.currentPage + 1), 1)
            ], 512), [
              [_vShow, _ctx.currentPage + 1 < _ctx.pages.length]
            ]),
            _withDirectives(_createElementVNode("li", null, _hoisted_11, 512), [
              [_vShow, _ctx.currentPage + 2 < _ctx.pages.length]
            ]),
            _withDirectives(_createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "pagination-link button",
                "aria-label": "Ir a la última página",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPaginationClick(_ctx.pages.length)))
              }, _toDisplayString(_ctx.pages.length), 1)
            ], 512), [
              [_vShow, _ctx.currentPage < _ctx.pages.length]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}